import { render, staticRenderFns } from "./Morhipo.vue?vue&type=template&id=03d4da27&scoped=true"
import script from "./Morhipo.vue?vue&type=script&lang=js"
export * from "./Morhipo.vue?vue&type=script&lang=js"
import style0 from "./Morhipo.vue?vue&type=style&index=0&id=03d4da27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d4da27",
  null
  
)

export default component.exports